import React, { useState, useEffect } from 'react';
import { Col, Form, FormGroup, Input, Button, CardBody, CardHeader, Spinner } from 'reactstrap';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import './CatchmentContext.css';
import useAuth from "../Utilities/Hooks/useAuth";

const animatedComponents = makeAnimated();

const PriorityContaminants = () => {

    const [description, setDescription] = useState('');
    const [saving, setSaving] = useState('');
    const [contaminantList, setContaminantList] = useState('');
    const [selectedContaminants, setSelectedContaminants] = useState('');
    const [savedContaminantsList, setSavedContaminantsList] = useState('');
    const [farmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId] = useState(localStorage.getItem("loggedInUserId"));
    const { auth } = useAuth();

    useEffect(() => {
        getPriorityContaminants();
    }, [], selectedContaminants)

    const getPriorityContaminants = async () => {
        try {
            const response = await axios.get(
                '/api/catchmentcontext/getprioritycontaminants/', {
                headers: {
                    "Authorization": `Bearer ${auth.token}`
                },
                params: {
                    farmId: farmId
                }
            });

            setDescription(response?.data?.description);
            setSavedContaminantsList(response?.data?.savedContaminantList);
            setContaminantList(response?.data?.contaminantList);

        } catch (error) {
            if (!error?.response) {
                toast.error(error.response?.status + ": " + error.message, { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("No server response", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        setSaving(true);

        try {
            const response = await axios.post(
                '/api/catchmentcontext/saveprioritycontaminants/',
                JSON.stringify(
                    {
                        description, selectedContaminants, farmId, userId
                    }), {
                headers: { 'Content-Type': 'application/json' }
            });

            setTimeout(() => {
                setSaving(false);
            }, 1000)

            toast.success("Priority Contaminants Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });

            getPriorityContaminants();

        } catch (err) {
            setTimeout(() => {
                setSaving(false);
            }, 1000)


            if (!err?.response) {
                toast.error("No server response!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else if (err.response?.status === 400) {
                toast.error("Saving Priority Contaminants Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            } else {
                toast.error("Saving Priority Contaminants Failed!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
    }

    return (
        <>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />

            <CardHeader className="card-header-dark">
                <h5>Priority Contaminants</h5>
            </CardHeader>
            <CardBody>
                <p>Contaminants of concern based on water quality state and trend data - <b>{savedContaminantsList}</b></p>

                <Form onSubmit={handleSubmit}>
                    <Col sm={12}>
                        <FormGroup style={{ display: "none" }}>
                            <Input
                                name="priorityContaminant"
                                disabled={true}
                                type="text"
                                value={savedContaminantsList}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Input
                                id="description"
                                name="description"
                                type="textarea"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </FormGroup>

                        {saving ?
                            <Button style={{ float: "right" }}
                                color="success"
                                disabled
                            >
                                <Spinner size="sm">
                                    Saving...
                                </Spinner>
                                <span>
                                    {' '}Saving
                                </span>
                            </Button>
                            :
                            <Button style={{ float: "right" }} color="success" size="sm">
                                Save
                            </Button>
                        }

                    </Col>
                </Form>
            </CardBody>
        </>
    )
}

export default PriorityContaminants;